// types
import { MenuProps } from 'types/menu';
import { createSlice } from '@reduxjs/toolkit';

// Get initial drawer state from localStorage, default to true (expanded)
const getInitialDrawerState = (): boolean => {
  const savedState = localStorage.getItem('sidebarOpen');
  if (savedState !== null) {
    return savedState === 'true';
  }
  return true; // Default to expanded
};

// initial state
const initialState: MenuProps = {
  openItem: ['dashboard'],
  openComponent: 'buttons',
  drawerOpen: getInitialDrawerState(),
  componentDrawerOpen: true
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    }
  }
});

export default menu.reducer;

export const { activeItem, activeComponent, openDrawer, openComponentDrawer } = menu.actions;
